import React from "react";

// Beacons brand mark — vertical-stack lozenges (link-in-bio identity)
export const BeaconsIcon = ({ size = 18, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* three stacked pills that look like a link tree */}
    <rect x="7" y="3" width="10" height="4" rx="2" />
    <rect x="4" y="10" width="16" height="4" rx="2" />
    <rect x="7" y="17" width="10" height="4" rx="2" />
  </svg>
);

export default BeaconsIcon;
